import { render } from "./SalaryIntro.vue?vue&type=template&id=2c22f3a5&scoped=true"
const script = {}

import "./SalaryIntro.vue?vue&type=style&index=0&id=2c22f3a5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c22f3a5"

export default script